import React from 'react';
import { SubscriptionPlan } from '@/app/_lib/interfaces';
import moment from 'moment';

const PlanCard = ({
  subscriptionPlan,
}: {
  subscriptionPlan: SubscriptionPlan;
}) => {
  const { tagline, features, status, expires_date } = subscriptionPlan;

  return (
    <div data-test-id="plan-details-content">
      {status === 'active' && expires_date ? (
        <p className="mb-3">
          Active until {moment(expires_date).format('MMM DD, YYYY')}.
        </p>
      ) : null}

      <p>{tagline}</p>

      <ul className="list-disc list-inside">
        {features.map((feature) => (
          <li key={feature}>{feature}</li>
        ))}
      </ul>
    </div>
  );
};

export default PlanCard;
